{
    "locale": "da-DK",
    "General": {
        "OrText": "Eller",
        "Title_MyHubert": "My Hubert",
        "Button_GoTo_MyHubert": "Gå til My Hubert"
    },
    "Header": {
        "ButtonText_CreateNewAccount": "Opret ny konto",
        "ButtonText_SignInToYourAccount": "Log ind på din konto",
        "ButtonText_StartInterviewWithoutSigningUp": "Start interview uden at oprette konto",
        "ButtonText_StartInterviewWithoutSigningIn": "Start interview uden at logge ind",
        "Navlink_Dashboard": "Overblik",
        "Navlink_MyInterviews": "Mine interviews",
        "Navlink_LearnWithHubert": "Lær med Hubert",
        "Navlink_HelpCenter": "Hjælpecenter",
        "MyProfile": "Min profil",
        "LogOut": "Log ud"
    },
    "Login": {
        "MainTitle": "Se resultaterne af dine Hubert-interview",
        "Subtitle": "Log ind for at se resultater, modtag feedback, læs om gode råd og meget mere.",
        "LoginTitle": "Log ind på din Hubert-konto",
        "Label_Email": "E-mail",
        "Label_Password": "Adgangskode",
        "ButtonText_SignIn": "Log ind",
        "ButtonText_ForgotPassword": "Glemt adgangskode?",
        "ButtonText_ContinueWithGoogle": "Fortsæt med Google",
        "OrSeparator": "Eller",
        "Error_Email_Required": "E-mail er påkrævet.",
        "Error_Email_Invalid": "Indtast en gyldig e-mail.",
        "Error_Password_Required": "Adgangskode er påkrævet.",
        "Error_Use_Same_Email_As_Interview": "Brug den samme e-mail, som du brugte i interviewet."
    },
    "Registration": {
        "MainTitle": "Se resultaterne af dit Hubert-interview",
        "Subtitle": "Opret en konto for at se resultater, modtag feedback, læs om gode råd og meget mere.",
        "RegistrationTitle": "Opret Hubert-konto",
        "BenefitsBox_Title": "Du kan:",
        "BenefitsBox_Point1": "Se din interviewhistorik",
        "BenefitsBox_Point2": "Få feedback på dine interviews",
        "BenefitsBox_Point3": "Genbrug svar i nye interviews",
        "BenefitsBox_Point4": "Få råd vedrørende interviews",
        "BenefitsBox_Point5": "Læs karriereguider",
        "BenefitsBox_Point6": "Og meget mere",
        "Label_FirstName": "Fornavn",
        "Label_LastName": "Efternavn",
        "Label_Email": "E-mail",
        "Label_Password": "Adgangskode",
        "Label_PhoneNumber": "Telefonnummer",
        "Label_TermsOfService": "Jeg accepterer",
        "Label_TermsOfServiceLink": "Privatlivspolitik og vilkår",
        "Placeholder_CountryCode": "Vælg landekode",
        "Placeholder_PhoneNumber": "20123456",
        "HelpText_Password": "Adgangskoden skal være mindst 6 tegn.",
        "ButtonText_SignUp": "Opret konto",
        "ButtonText_SignUpWithGoogle": "Opret en konto med Google",
        "OrSeparator": "Eller",
        "Error_FirstName_Required": "Fornavn er påkrævet.",
        "Error_LastName_Required": "Efternavn er påkrævet.",
        "Error_Email_Required": "E-mail er påkrævet.",
        "Error_Email_Invalid": "Indtast en gyldig e-mail.",
        "Error_Email_Exists": "E-mailen er allerede i brug.",
        "Error_Password_Required": "Adgangskode er påkrævet.",
        "Error_Password_6_Characters": "Adgangskoden skal være mindst 6 tegn.",
        "Error_PhoneNumber_Required": "Telefonnummer er påkrævet.",
        "Error_PhoneNumber_Invalid": "Telefonnummeret er ikke gyldigt.",
        "Error_PrivacyPolicyCheck_Required": "Privatlivspolitik og vilkår skal accepteres."
    },
    "RegistrationInviteEmail": {
        "Subtitle_BeforeInterviewCompleted": "For at tage interviewet skal du acceptere vilkårene for at bruge Hubert. Sæt blot flueben i boksen for at fortsætte.",
        "Subtitle_AfterInterviewCompleted": "Opret en konto for at se resultater, få feedback, læse råd og meget mere.",
        "PrivacyPolicyText": "Ved at trykke på Opret konto accepterer du",
        "PrivacyPolicyLink": " Privatlivspolitik og vilkår",
        "ButtonText_SignUp": "Opret konto og gå til interviewet",
        "ButtonText_SignUpNormal": "Opret konto",
        "ButtonText_SignInInstead": "Klik her for at logge ind i stedet"
    },
    "LoginInviteEmail": {
        "Subtitle": "Log ind for at se resultater, modtag feedback, få råd og meget mere."
    },
    "AppMessages": {
        "internal-server-error": "Der opstod en uventet fejl.",
        "invalid-credentials": "Ugyldige loginoplysninger. Prøv igen.",
        "user-not-found": "Ugyldige loginoplysninger. Prøv igen.",
        "account-not-found": "Ugyldig konto. Prøv igen.",
        "verify-email-title": "Bekræft din e-mail",
        "verify-email-subtitle": "Tjek din e-mail for at bekræfte din konto.",
        "email-not-verified-title": "E-mail er endnu ikke bekræftet",
        "email-not-verified-subtitle": "Tjek din e-mail for at bekræfte din konto.",
        "verifying-email-title": "Bekræfter e-mail",
        "verifying-email-subtitle": "Vent venligst ...",
        "sign-in-title": "Logger ind",
        "sign-in-subtitle": "Vent venligst ...",
        "server-error": "Noget gik galt.",
        "hubert-user-exists": "Kontoen findes allerede.",
        "account-exists": "Kontoen findes allerede.",
        "email-verified": "Din e-mail er blevet bekræftet.",
        "email-is-taken": "E-mailen er allerede i brug.",
        "re-enter-password": "Brug din adgangskode til at logge ind",
        "password-reset": "Din adgangskode er blevet ændret.",
        "re-enter-new-password": "Brug din nye adgangskode til at logge ind",
        "invalid-invitation": "Ugyldig invitation.",
        "invalid-code": "Ugyldig bekræftelseskode.",
        "email-already-verified": "E-mailen er allerede bekræftet.",
        "email-mismatch-title": "E-mail matcher ikke",
        "email-mismatch-subtitle": "Brug den samme e-mailadresse, som du brugte til at søge stillingen."
    },
    "TransitionPage": {
        "loading-title": "Indlæser ...",
        "loading-subtitle": "Indlæser dine data ...",
        "logout-title": "Indlæser ...",
        "logout-subtitle": "Logger dig ud ..."
    },
    "ImpersonationPage": {
        "loading-title": "Indlæser ...",
        "loading-subtitle": "Indlæser dine data ..."
    },
    "ProcessInvitation": {
        "loading-title": "Indlæser ...",
        "loading-subtitle": "Vent et øjeblik, mens vi indlæser dit interview.",
        "InvitationNotFound": "Vi kunne ikke finde dit interview.",
        "InvitationExpired": "Linket til interviewet er udløbet.",
        "InvitationExpired_Description1": "Åbn interviewet via",
        "InvitationExpired_Description2": "eller kontakt din rekrutterer.",
        "InvitationInvalid": "Linket til denne invitation er ugyldigt.",
        "InterviewCompleted": "Dette interview er allerede gennemført."
    },
    "Common": {
        "MyInterviews": {
            "Title": "Mine interviews",
            "TableHead_Employer": "Arbejdsgiver",
            "TableHead_Job": "Stilling",
            "TableHead_Status": "Status",
            "TableHead_ApplicationDate": "Ansøgningsdato",
            "TableBody_StartInterview": "Interviewet er ikke gennemført. Klik her for at starte eller fortsætte interviewet.",
            "TableBody_NotScored": "Interviewet er gennemført. Resultaterne er klar om lidt.",
            "TableBody_Details": "Klik her for at se resultater og mere.",
            "ApplicationDate_Invited": "Inviteret",
            "ApplicationDate_MinuteAgo": "minut siden",
            "ApplicationDate_MinutesAgo": "minutter siden",
            "ApplicationDate_HourAgo": "time siden",
            "ApplicationDate_HoursAgo": "timer siden",
            "ApplicationDate_DayAgo": "dag siden",
            "ApplicationDate_DaysAgo": "dage siden",
            "ButtonText_SeeAllInterviews": "Se alle interviews",
            "ButtonText_Details": "Detaljer",
            "ButtonText_StartInterview": "Gå til interview",
            "ButtonText_NotScored": "Resultaterne afventes",
            "NoInterviews_Message": "Du har ingen tidligere eller kommende interviews."
        },
        "LatestJobPostings": {
            "NoJobPostings": "Der er ingen stillingsopslag lige nu. Prøv igen senere."
        }
    },
    "Dashboard": {
        "MyCareer": {
            "Title": "Min karriere",
            "Subtitle": "Vælg et interview for at se vurderingen og dine muligheder.",
            "MostRecentInterview": "Seneste interview",
            "ToDo": "Gøremål",
            "NoOngoingInterviews_Title": "Ingen nye interviewinvitationer endnu.",
            "NoOngoingInterviews_Subtitle": "Nye Hubert-interviews vises her, så snart de er planlagt af rekrutterere.",
            "NoRecentInterviews_Title": "Ingen tidligere interviews fundet.",
            "NoRecentInterviews_Subtitle": "Når du bliver inviteret til et interview, vises det herunder.",
            "ButtonText_StartInterview": "Gå til interview",
            "ButtonText_NotScored": "Resultatet afventer",
            "ButtonText_Details": "Detaljer"
        },
        "LearnWithHubert": {
            "Title": "Lær med Hubert",
            "Subtitle": "Få råd til, hvordan du kan blive bedre til interviews og præstere bedre i jobbet.",
            "PickedForMe": "Seneste artikler",
            "ButtonText_SeeAllArticles": "Se alle artikler"
        },
        "HubertTip": {
            "Title": "Hubert-tip",
            "Subtitle": "Gennemfør interviews hurtigere",
            "Description": "Søger du et nyt job i en lignende stilling, som du tidligere har taget et Hubert-interview til? Du kan genbruge dine svar fra det forrige interview og spare tid.",
            "ButtonText_ReadMoreTips": "Læs flere tips"
        },
        "NewCandidateModalPopup": {
            "Title": "Du er klar.",
            "DescriptionLine1": "Din konto er klar.",
            "DescriptionLine2": "Administrér dine interviews og din profil. Se dine resultater, få feedback, og lær mere om, hvordan du forbedre dine interviews.",
            "ButtonText_LetsGo": "Kom godt i gang"
        },
        "InterviewCompletedModal": {
            "Title": "Godt arbejde.",
            "Subtitle": "Du har gennemført dit interview.",
            "Description": "Rekrutterere gennemgår alle ansøgninger og vender tilbage via e-mail eller telefon, så snart der er en opdatering.",
            "ButtonText_Continue": "Fortsæt"
        },
        "LatestJobPostings": {
            "Title": "Seneste stillingsopslag",
            "Subtitle": "Se andre nylige stillingsopslag fra Hubert-partnere."
        }
    },
    "MyInterviews": {
        "MyInterviewsSection_Title": "Mine interviews",
        "MyInterviewsSection_Subtitle": "Vælg et interview for at se vurderingen og dine karrieremuligheder.",
        "MyInterviewsSection_ToDo": "Gøremål"
    },
    "Interview": {
        "ButtonText_SeeAllInterviews": "Se alle interviews",
        "InterviewNotFound_Title": "Interviewet kan ikke åbnes",
        "InterviewNotFound_Description": "Du forsøger at åbne interviewdetaljer, der ikke er knyttet til din konto.",
        "ButtonText_GoToAllInterviews": "Gå til Mine interviews",
        "InterviewDetails": {
            "Title": "Interviewdetaljer",
            "ForRole": "For stillingen",
            "InterviewCompletedOn": "Interview gennemført den {{date}} kl. {{time}}"
        },
        "MyResult": {
            "Title": "Mit resultat",
            "Subtitle": "Vurderet match",
            "ButtonText_LearnMore": "Se hvordan dine svar vurderes",
            "GotPotential_Title": "Stærkt potentiale, mangler et krav",
            "GotPotential_Description": "Dine svar viser stærkt potentiale for denne type stilling. Ud fra interviewet opfylder du måske ikke et eller flere krav til netop denne stilling. Det kan påvirke næste skridt, afhængigt af rekruttererens behov og antallet af kandidater. Hvis du ikke bliver inviteret til næste fase, siger det ikke noget om dit potentiale som kandidat. Ofte handler det om et præcist match til stillingens konkrete behov. Se andre muligheder og forbedringstips nedenfor.",
            "GotPotential_DescriptionSecondary": "Huberts vurdering er kun vejledende for rekruttereren. Det er rekruttereren, der beslutter, om du bliver inviteret til næste trin i processen. Det afhænger af flere ting, fx hvor mange andre kandidater der matcher stillingen.",
            "GreatMatch_Title": "Stærkt match",
            "GreatMatch_Description": "Dine svar stemmer godt overens med det, rekrutterere typisk leder efter for denne stilling, og du opfylder stillingens krav. Godt arbejde. Rekruttereren gennemgår alle kandidater og beslutter næste skridt.",
            "GreatMatch_DescriptionSecondary": "Huberts vurdering er kun vejledende for rekruttereren. Det er rekruttereren, der beslutter, om du bliver inviteret til næste trin i processen. Det afhænger af flere ting, fx hvor mange andre kandidater der matcher stillingen. Hvis du ikke bliver inviteret til næste fase, siger det ikke noget om dit potentiale som kandidat. Ofte handler det om et præcist match til stillingens konkrete behov. Se andre muligheder og forbedringstips nedenfor.",
            "OkMatch_Title": "Kvalificeret, tilføj mere for at øge chancerne",
            "OkMatch_Description": "Du opfylder stillingens krav. For at skille dig mere ud kan dine svar have gavn af mere klarhed og konkrethed end det, rekrutterere typisk ser i denne stilling. Gennemgå dine svar nedenfor og se, hvor et konkret eksempel eller et tydeligt resultat kan løfte din samlede vurdering.",
            "OkMatch_DescriptionSecondary": "Huberts vurdering er kun vejledende for rekruttereren. Det er rekruttereren, der beslutter, om du bliver inviteret til næste trin i processen. Det afhænger af flere ting, fx hvor mange andre kandidater der matcher stillingen.",
            "NotClearMatch_Title": "Måske ikke det rette match (endnu)",
            "NotClearMatch_Description": "Ud fra interviewet kan dine svar være mindre i tråd med, hvad rekruttereren leder efter til denne stilling, eller du opfylder måske ikke et eller flere krav. Hvis du ønsker at forbedre dig, så start med spørgsmålene nedenfor. Små ændringer, mere konkrethed og tydelige resultater kan gøre en stor forskel næste gang.",
            "NotClearMatch_DescriptionSecondary": "Huberts vurdering er kun vejledende for rekruttereren. Det er rekruttereren, der beslutter, om du bliver inviteret til næste trin i processen. Det afhænger af flere ting, fx hvor mange andre kandidater der matcher stillingen."
        },
        "ScoreBox": {
            "ProfessionalExperiences": "Erhvervserfaring, motivation og kompetencer",
            "QualifyingRequirements": "Kvalificerende krav til netop denne stilling",
            "NotQualified_Title": "Styrk dine svar",
            "NotQualified_Description": "Dine svar kan have været mindre specifikke eller mindre resultatorienterede, end rekruttereren forventer til denne stilling. Se nedenfor, hvor et konkret eksempel, specifikke handlinger eller et tydeligt resultat kan styrke dit svar.",
            "GreatResults_Title": "Stærke svar",
            "GreatResults_Description": "Dine svar tyder på, at du passer til denne type stilling og kommunikerede tydeligt. Hvis et spørgsmål kan styrkes, bliver det fremhævet nedenfor.",
            "MeetingRequirements_Title": "Krav opfyldt",
            "MeetingRequirements_Description": "Dine svar tyder på, at du opfylder de kvalificerende krav til stillingen. Det er et godt udgangspunkt.",
            "NotAllExpectationsMet_Title": "Et eller flere krav mangler",
            "NotAllExpectationsMet_Description": "Ud fra dine svar opfylder du måske ikke et eller flere af de kvalificerende krav til netop denne stilling, fx certifikater, licenser, uddannelsesniveau eller antal års erfaring.",
            "ButtonText_FindOutPossibleReasons": "Se detaljer"
        },
        "ScriptFromInterview": {
            "Title": "Læs hele interviewet",
            "ButtonText_SeeWholeTranscript": "Læs interview",
            "ButtonText_DeleteInterview": "Slet interview",
            "Loading_Title": "Indlæser ...",
            "Loading_Subtitle": "Vent et øjeblik, mens vi indlæser dit interviewudskrift."
        },
        "HowToImproveAtInterviews": {
            "Title": "Sådan bliver du bedre til interviews",
            "Subtitle_Questions": "Her er nogle spørgsmål, hvor vi mener, at dit svar kan forbedres.",
            "Subtitle_NoQuestions": "Vi fandt ingen svar, der har tydelige forbedringspunkter for netop denne stilling.",
            "GreatMatch_Questions_Description": "Selv om du virker som et stærkt match til stillingen, kan der stadig være svar, der kan forbedres. Hvis vi har identificeret sådanne svar, finder du dem nedenfor. Som tommelfingerregel for at få en høj vurdering i et Hubert-interview: Følg instruktionerne før hvert spørgsmål. Når et spørgsmål handler om en konkret situation, så beskriv situationen, hvad du gjorde, og hvilket resultat det gav. At svare “OK” er ikke uddybende nok. Samtidig behøver du ikke skrive alt for langt. Svar så rekruttereren (og Hubert) nemt kan få et overblik over dine kompetencer og erfaringer, som i et almindeligt interview ansigt til ansigt.",
            "GreatMatch_NoQuestions_Description": "Du klarede dig sandsynligvis godt ved alle eller de fleste spørgsmål. Godt arbejde.",
            "OkMatch_Questions_Description": "Nedenfor finder du spørgsmål, hvor dit svar kan styrkes. Som tommelfingerregel for at få en høj vurdering i et Hubert-interview: Følg instruktionerne før hvert spørgsmål. Når et spørgsmål handler om en konkret situation, så beskriv situationen, hvad du gjorde, og hvilket resultat det gav. At svare “OK” er ikke uddybende nok. Samtidig behøver du ikke skrive alt for langt. Svar så rekruttereren (og Hubert) nemt kan få et overblik over dine kompetencer og erfaringer, som i et almindeligt interview ansigt til ansigt.",
            "OkMatch_NoQuestions_Description": "Når du er vurderet som et OK match til netop denne stilling, kan det virke mærkeligt, at ingen svar er markeret som forbedringspunkter. Det kan dog være, at rekruttereren har sat en høj bar, hvilket ofte sker ved stor konkurrence med mange stærke kandidater. Så selv om dine svar var gode, kan andre kandidater have leveret lige så gode eller endnu bedre svar.",
            "OkMatch_NoQuestions_DescriptionSecondary": "Som tommelfingerregel for at få en høj vurdering i et Hubert-interview: Følg instruktionerne før hvert spørgsmål. Når et spørgsmål handler om en konkret situation, så beskriv situationen, hvad du gjorde, og hvilket resultat det gav. At svare “OK” er ikke uddybende nok. Samtidig behøver du ikke skrive alt for langt. Svar så rekruttereren (og Hubert) nemt kan få et overblik over dine kompetencer og erfaringer, som i et almindeligt interview ansigt til ansigt.",
            "GotPotential_Questions_Description": "Selv om du virker som et stærkt match til denne type job, kan der stadig være svar, der kan styrkes. Hvis vi har identificeret sådanne svar, finder du dem nedenfor. Som tommelfingerregel: Følg instruktionerne før hvert spørgsmål. Når et spørgsmål handler om en konkret situation, så beskriv situationen, hvad du gjorde, og hvilket resultat det gav. At svare “OK” er ikke uddybende nok. Samtidig behøver du ikke skrive alt for langt. Svar så rekruttereren (og Hubert) nemt kan få et overblik over dine kompetencer og erfaringer, som i et almindeligt interview ansigt til ansigt.",
            "GotPotential_NoQuestions_Description": "Vi fandt ingen svar, der kræver større forbedringer ift. faglige kompetencer og motivation for denne type stilling. Du ser ud til at have svaret godt på de emner.",
            "NotClearMatch_Questions_Description": "Nedenfor finder du spørgsmål, hvor dit svar kan styrkes. Som tommelfingerregel: Følg instruktionerne før hvert spørgsmål. Når et spørgsmål handler om en konkret situation, så beskriv situationen, hvad du gjorde, og hvilket resultat det gav. At svare “OK” er ikke uddybende nok. Samtidig behøver du ikke skrive alt for langt. Svar så rekruttereren (og Hubert) nemt kan få et overblik over dine kompetencer og erfaringer, som i et almindeligt interview ansigt til ansigt.",
            "NotClearMatch_NoQuestions_Description": "Vi fandt ingen svar med tydelige forbedringspunkter for netop denne stilling. Når du samtidig ikke vurderes som et klart match, kan det virke mærkeligt. Det kan dog være, at rekruttereren har sat en høj bar, hvilket ofte sker ved stor konkurrence med mange stærke kandidater. Så selv om dine svar var tilfredsstillende, kan andre kandidater have leveret lige så gode eller endnu bedre svar.",
            "NotClearMatch_NoQuestions_DescriptionSecondary": "Som tommelfingerregel for at få en høj vurdering i et Hubert-interview: Følg instruktionerne før hvert spørgsmål. Når et spørgsmål handler om en konkret situation, så beskriv situationen, hvad du gjorde, og hvilket resultat det gav. At svare “OK” er ikke uddybende nok. Samtidig behøver du ikke skrive alt for langt. Svar så rekruttereren (og Hubert) nemt kan få et overblik over dine kompetencer og erfaringer, som i et almindeligt interview ansigt til ansigt.",
            "Alert_WantMoreAdvice": "Vil du have flere råd til at klare dig godt i et Hubert-interview?",
            "AlertLink_ExploreOurGeneralAdviceArticle": "Se vores generelle artikel med gode råd"
        },
        "SimilarOffers": {
            "Title": "Lignende stillinger"
        },
        "HowHubertScoresInterviews": {
            "Title": "Hvordan vurderer Hubert interviews?",
            "Description": "Nedenfor finder du en kort forklaring på, hvordan Hubert vurderer interviewsvar. Vi har også tilføjet afsnittet Rekrutteringsproces, som en hjælpende hånd for at forklare, hvad de næste skridt typisk er efter et Hubert-interview.",
            "Tabs_PossibleOutcomes": "Mulige udfald",
            "Tabs_RecruitmentProcess": "Rekrutteringsproces",
            "AssessedMatch_Title": "Vurderet match",
            "AssessedMatch_Description": "Hubert vurderer, hvordan dine svar samlet set matcher det, rekrutterere forventer til denne stilling. Hubert tjekker også, om du opfylder de grundlæggende krav til jobbet. Afhængigt af dine svar og om du opfylder kravene, placeres du i én af de fire kategorier nedenfor.",
            "AssessedMatch_DescriptionSecondary": "Huberts vurdering er kun vejledende for rekruttereren. Det er rekruttereren, der beslutter, om du bliver inviteret til næste trin i processen. Det afhænger af flere ting, fx hvor mange andre kandidater der matcher stillingen.",
            "GreatMatch_Title": "Stærkt match",
            "GreatMatch_Description": "Dine svar matcher rekruttererens forventninger til stillingen. Du har fået en stærk vurdering af dine svar, og du opfylder de grundlæggende krav til jobbet.",
            "GotPotential_Title": "Stærkt potentiale, mangler et krav",
            "GotPotential_Description": "Du har fået en stærk vurdering på erfaring, motivation og/eller kompetencer, der passer til stillingen generelt. Samtidig opfylder du dog ikke et eller flere grundlæggende krav til netop denne stilling.",
            "OkMatch_Title": "Kvalificeret, tilføj mere for at øge chancerne",
            "OkMatch_Description": "Du opfylder de grundlæggende krav til jobbet, men dine svar kan være vurderet lavere end det niveau, rekrutterere typisk forventer til denne stilling.",
            "NotClearMatch_Title": "Måske ikke det rette match (endnu)",
            "NotClearMatch_Description": "Dine svar er vurderet lavere end det niveau, rekrutterere typisk forventer til stillingen. Derudover tyder dine svar på, at du ikke opfylder et eller flere grundlæggende krav, som rekruttereren har sat for jobbet.",
            "ProfessionalExperiences_Title": "Erhvervserfaring, motivation og kompetencer",
            "ProfessionalExperiences_Description": "Spørgsmålet fokusere på din tidligere erfaring, din motivation for jobbet og de kompetencer, der er relevante for stillingen. Rekruttereren bestemmer, hvilke spørgsmål der indgår i interviewet til den konkrete stilling.",
            "GreatResults_Title": "Stærke resultater",
            "GreatResults_Description": "Det betyder, at dine svar tyder på, at du passer til den stilling, du har søgt.",
            "NotQualified_Title": "Der er plads til forbedring",
            "NotQualified_Description": "Det betyder, at dine svar samlet set er vurderet lavere end det niveau, rekruttereren har sat som forventning til denne stilling.",
            "QualifyingRequirements_Title": "Grundlæggende eller kvalificerende krav til netop denne stilling",
            "QualifyingRequirements_Description": "Det er spørgsmål, som rekruttereren har sat som kvalificerende krav til jobbet. Det kan fx være et påkrævet certifikat (fx kørekort) eller et bestemt niveau af relevant erfaring.",
            "MeetingRequirements_Title": "Krav opfyldt",
            "MeetingRequirements_Description": "Dine svar tyder på, at du opfylder de kvalificerende krav, som rekruttereren har sat for stillingen.",
            "NotAllExpectationsMet_Title": "Et eller flere krav mangler",
            "NotAllExpectationsMet_Description": "Ud fra dine svar opfylder du måske ikke et eller flere af de kvalificerende krav til netop denne stilling, som rekruttereren har sat.",
            "RecruitmentProcess_Title": "Rekrutteringsproces",
            "RecruitmentProcess_Description": "Hubert bruges typisk som første skridt i en rekrutteringsproces med mange kandidater. Det gør det muligt for alle kandidater at gennemføre et interview og fortælle om sig selv med egne ord. Da interviewspørgsmålene er de samme for alle kandidater til den samme stilling, bliver processen mere ensartet. Hubert bruger heller ikke information som alder, køn, etnicitet, religion eller udseende, hvilket kan mindske risikoen for ubevidste bias.",
            "EventOne_Title": "Du interviewes af Hubert",
            "EventOne_Description": "Du tager interviewet med Hubert, når og hvor det passer dig bedst. Der er ingen tidsbegrænsning, og du kan holde pause når som helst og fortsætte, hvor du slap.",
            "EventTwo_Title": "Dit interview vurderes",
            "EventTwo_Description": "Hubert vurderer dine svar ved hjælp af moderne teknologi. Så snart vurderingen er færdig, kan du se resultaterne her i My Hubert, og rekruttereren kan se dem i deres ansøgningssystem.",
            "EventThree_Title": "Rekruttereren vælger kandidater til næste skridt",
            "EventThree_Description": "I deres ansøgningssystem kan rekrutterere se, når et nyt Hubert-interviewresultat er tilgængeligt. De kan derefter gennemgå dine svar og Huberts vurdering. På baggrund af Huberts vejledende vurdering og deres egen vurdering beslutter rekruttereren, om du inviteres til næste trin. Det kan fx være et opkald, en test eller et sidste interview. Alternativt kan rekruttereren vælge at afvente. Eller, hvis andre kandidater matcher bedre, kan din ansøgning blive afvist.",
            "ButtonText_Close": "Luk"
        }
    },
    "MyProfile": {
        "Title": "Min profil",
        "MyDetails": {
            "Title": "Mine oplysninger",
            "Label_FirstName": "Fornavn",
            "Label_LastName": "Efternavn",
            "Label_Email": "E-mail",
            "Label_PhoneNumber": "Telefonnummer",
            "ButtonText_UpdateDetails": "Opdater oplysninger",
            "Error_FirstName_Required": "Fornavn er påkrævet.",
            "Error_LastName_Required": "Efternavn er påkrævet.",
            "Error_Email_Required": "E-mail er påkrævet.",
            "Error_Email_Invalid": "Indtast en gyldig e-mail.",
            "Error_PhoneNumber_Invalid": "Telefonnummeret er ikke gyldigt.",
            "Success_Details_Updated": "Din profil blev opdateret."
        },
        "ChangePassword": {
            "Title": "Skift adgangskode",
            "Set_Password_Title": "Opret adgangskode",
            "Label_CurrentPassword": "Nuværende adgangskode",
            "Label_NewPassword": "Ny adgangskode",
            "Label_RepeatNewPassword": "Bekræft ny adgangskode",
            "Alert_SignInAgain": "Log venligst ind igen for at oprette din adgangskode.",
            "ButtonText_UpdatePassword": "Opdater adgangskode",
            "ButtonText_SetPassword": "Opret adgangskode",
            "ButtonText_SignInAgain": "Log ind igen",
            "Error_CurrentPassword_Required": "Nuværende adgangskode er påkrævet.",
            "Error_CurrentPassword_DoesntMatch": "Adgangskoden matcher ikke din nuværende adgangskode.",
            "Error_NewPassword_Required": "Ny adgangskode er påkrævet.",
            "Error_NewPassword_6_Characters": "Din nye adgangskode skal være mindst 6 tegn.",
            "Error_RepeatNewPassword_Required": "Bekræft ny adgangskode er påkrævet.",
            "Error_RepeatNewPassword_DoesntMatch": "Adgangskoderne matcher ikke.",
            "Success_Password_Changed": "Adgangskoden er opdateret.",
            "Error_Invalid_CurrentPassword": "Din nuværende adgangskode er ugyldig."
        },
        "NotificationPreferences": {
            "Title": "Notifikationsindstillinger",
            "Label_ReceiveUpdatesToggle": "Jeg ønsker at modtage opdateringer fra Hubert.",
            "Label_ReceiveUpdatesToggleHelpText": "Du får karriereguider, interviewtips og meget mere."
        },
        "AccountRemoval": {
            "Title": "Slet konto",
            "ButtonText_RemoveMyAccount": "Slet min konto"
        }
    },
    "PreInterviewPage": {
        "Title_Hello": "Hej",
        "Subtitle": "Du er ved at starte dit jobinterview.",
        "TipBox_Title": "Her er nogle tips, der måske kan hjælpe dig.",
        "TipBox_Tip1": "Gennemfør interviewet et trygt sted, hvor du bedre kan koncentrere dig og skrive i ro.",
        "TipBox_Tip2": "Svar gerne på en computer med tastatur, medmindre du er komfortabel med at skrive længere svar på mobilen.",
        "TipBox_Tip3": "Vær så konkret og detaljeret som muligt i dine svar. Hubert og rekruttereren vil gerne have det bedste overblik over dine kompetencer og erfaring.",
        "TipBox_Tip4": "Tag den tid, du har brug for. Der er ingen tidsbegrænsning.",
        "TipBox_Tip5": "Du kan holde pause når som helst og fortsætte, hvor du slap.",
        "TipBox_Tip6": "Vær dig selv og tag interviewet lige så seriøst som et almindeligt interview.",
        "CheckAdviceArticle_Text1": "Hvis du vil have flere tips til at lykkes i interviewet, så se denne",
        "CheckAdviceArticle_Text2": "artikel",
        "CheckAdviceArticle_Text3": "med gode råd.",
        "ReadyToGetStarted": "Er du klar til at gå i gang?",
        "ORSeparator_Text": "Eller",
        "ButtonText_StartInterviewNow": "Start interview nu",
        "ButtonText_SetReminder": "Jeg er ikke klar endnu, sæt en påmindelse",
        "PrivacyPolicyText": "Ved at starte interviewet accepterer du",
        "PrivacyPolicyLink": " Privatlivspolitik og vilkår"
    },
    "InterviewCompletedPageInviteEmail": {
        "CompletedAlert_Title": "Godt arbejde.",
        "CompletedAlert_Subtitle": "Du har gennemført dit interview.",
        "CompletedAlert_Description": "Rekrutterere gennemgår alle ansøgninger og vender tilbage via e-mail eller telefon, så snart der er en opdatering.",
        "InterviewNotCompleted": "Dette interview er ikke gennemført."
    },
    "HelpCenter": {
        "BannerSection": {
            "Title": "Hjælpecenter",
            "Subtitle": "Find svar på de mest almindelige spørgsmål vedrørende Hubert.",
            "Label_Search": "søg i ofte stillede spørgsmål",
            "ButtonText_Search": "Søg"
        },
        "FAQSection": {
            "Tabs_All": "Alle",
            "Tabs_AboutHubertInterview": "Om Hubert-interviewet",
            "Tabs_TechnicalSupport": "Teknisk support"
        },
        "StillHaveQuestion": {
            "Title": "Har du stadig et spørgsmål?",
            "Description": "Vi hjælper gerne.",
            "DropUsAEmail": "Skriv til os på hubert@hubert.ai"
        },
        "Q&ATexts": {
            "AboutHubertInterview": [
                {
                    "q": "Kan jeg gennemføre interviewet via telefonopkald i stedet?",
                    "a": "Hubert fungerer kun via chat på nuværende tidspunkt. Hvis du har en medicinsk årsag, der gør, at du ikke kan gennemføre interviewet, så kontakt virksomheden direkte. Hubert er kun ansvarlig for chatinterviewet."
                },
                {
                    "q": "Kan jeg tage interviewet på et andet sprog?",
                    "a": "Nogle interviews giver mulighed for at vælge sprog i starten. Hvis du ikke ser den mulighed, er sproget sandsynligvis et krav til stillingen. For flere spørgsmål, kontakt rekrutteringsvirksomheden."
                },
                {
                    "q": "Bliver jeg straffet for at give korte svar?",
                    "a": "Nej, så længe du svarer på spørgsmålene som ønsket. Der er ingen minimumslængde for et svar, men flere detaljer hjælper ofte."
                },
                {
                    "q": "Kan jeg genbruge mine svar fra et andet interview med Hubert?",
                    "a": "Ja. Hvis du er logget ind i My Hubert og søger en lignende rolle, kan du genbruge tidligere svar."
                },
                {
                    "q": "Læser et menneske mit interview?",
                    "a": "Ja, vores kunder bliver bedt om at gennemgå interviews manuelt."
                },
                {
                    "q": "Jeg har gennemført interviewet. Hvad sker der nu?",
                    "a": "Når interviewet er gennemført, sendes resultaterne til rekruttereren i deres ansøgningssystem. Rekruttereren kan derefter gennemgå dine svar og Huberts vurdering. På baggrund af Huberts vejledende vurdering og deres egen vurdering beslutter de, om du inviteres til næste skridt. Det kan fx være et opkald, en test eller et sidste interview."
                },
                {
                    "q": "Jeg har spørgsmål til næste skridt i processen. Hvem skal jeg kontakte?",
                    "a": "Kontakt venligst virksomheden, hvor du har søgt stillingen."
                },
                {
                    "q": "Hvordan sikrer I, at I ikke introducerer bias i rekrutteringsprocessen?",
                    "a": "At reducere bias er vigtigt for os. Som system kan Hubert vurdere mere konsistent end mennesker. Vores modeller er trænet med mange ekspertvurderinger fra forskellige baggrunde. Derudover bruger Hubert ikke information som køn, alder, etnicitet, religion eller udseende, som ofte kan påvirke manuelle interviews."
                },
                {
                    "q": "Kan jeg blive interviewet af et menneske i stedet for Hubert?",
                    "a": "Kontakt venligst virksomheden, hvor du har søgt stillingen, hvis du vil spørge om det er en mulighed."
                },
                {
                    "q": "Er Hubert et menneske?",
                    "a": "Nej, Hubert er et computerbaseret interview- og analysesystem."
                },
                {
                    "q": "Kan jeg ændre mine svar senere?",
                    "a": "Nej. Ligesom i et almindeligt interview kan du ikke lave dine svar om, når de er sendt."
                },
                {
                    "q": "Hvordan klarer jeg mig bedst i et Hubert-interview?",
                    "a": "Læs spørgsmålene grundigt før du svarer. Følg instruktionerne. Brug konkrete eksempler fra din erfaring, og svar ærligt."
                },
                {
                    "q": "Jeg har brug for et job. Hvem skal jeg kontakte?",
                    "a": "Kontakt venligst virksomheden, hvor du har søgt."
                },
                {
                    "q": "Jeg har gennemført interviewet, men har ikke hørt noget. Hvad skal jeg gøre?",
                    "a": "Rekruttereren beslutter næste skridt ud fra Huberts vurdering og deres egen vurdering. Det kan være et opkald, en test eller et sidste interview. Hvis andre kandidater matcher bedre, kan din ansøgning blive afvist. Du kan kontakte rekruttereren for at høre statussen på din ansøgning."
                },
                {
                    "q": "Jeg har meget erfaring, men fik ikke jobbet. Hvorfor?",
                    "a": "Konkurrencen om en stilling kan være høj, og der kan være mange kvalificerede kandidater. Hvis din ansøgning blev afvist, kan du kontakte virksomheden og spørge hvorfor. Du kan også se feedback i My Hubert baseret på dine interviewsvar og se andre jobmuligheder."
                },
                {
                    "q": "Hvor lang tid tager interviewet?",
                    "a": "Det afhænger af antallet af spørgsmål, som rekruttereren har sat. Forvent typisk 10 til 25 minutter. Du behøver ikke skynde dig. Du kan holde pause og fortsætte senere."
                },
                {
                    "q": "Hvor kan jeg læse om, hvordan mine data håndteres?",
                    "a": "https://www.hubert.ai/candidate-privacy-policy"
                }
            ],
            "TechnicalSupport": [
                {
                    "q": "Hvorfor kan jeg ikke se mine tidligere Hubert-interviews?",
                    "a": "Sørg for, at du har brugt den samme e-mailadresse til at søge stillingen, som du bruger til at logge ind i My Hubert. Det gælder også ved Google-login: Google-e-mailen skal matche ansøgningens e-mail. Prøv at oprette en konto med den e-mailadresse, du søgte med."
                },
                {
                    "q": "Hvorfor modtog jeg ikke en e-mail om mit interview?",
                    "a": "Tjek din spammappe. Du kan også tilføje hubert@hubert.ai til dine kontakter. Alternativt kan du oprette en My Hubert-konto med den e-mail, du søgte med, og finde interviewlinket der."
                },
                {
                    "q": "Jeg kan ikke finde linket til mit interview i min e-mail.",
                    "a": "Tjek din spammappe. Alternativt kan du oprette en My Hubert-konto med den e-mail, du søgte med, og gå til 'Mine interviews' for at finde linket."
                },
                {
                    "q": "Fungerer interviewet på mobil?",
                    "a": "Ja. Men hvis du er mere komfortabel ved at skrive på en computer, anbefaler vi dog at bruge en."
                },
                {
                    "q": "Interviewet virker ikke. Hvad skal jeg gøre?",
                    "a": "Det er vi kede af at høre. Skriv til os på hubert@hubert.ai, så hjælper vi dig."
                },
                {
                    "q": "Jeg vil slette min konto i My Hubert. Hvad skal jeg gøre?",
                    "a": "Skriv til os på hubert@hubert.ai, så hjælper vi dig."
                },
                {
                    "q": "Interviewet blev afbrudt. Hvordan vender jeg tilbage?",
                    "a": "Klik på linket i e-mailinvitationen for at fortsætte, hvor du slap. Du kan også logge ind i My Hubert og vælge interviewet under 'Mine interviews'."
                }
            ]
        }
    },
    "LearnWithHubert": {
        "BannerSection": {
            "Title": "Lær med Hubert",
            "Subtitle": "Se hvordan du kan øge dine chancer i rekrutteringsprocessen og blive bedre til jobbet.",
            "Label_Search": "søg i interview- og karriereguider",
            "ButtonText_Search": "Søg"
        },
        "TabSelector": {
            "MyFeed": "Mit feed",
            "InterviewGuides": "Interviewguider",
            "CareerGuides": "Karriereguider"
        },
        "NewestOnTheFeed": "Nyeste i feedet",
        "PickedForMe": "Seneste artikler",
        "InterviewGuides": "Interviewguider",
        "CareerGuides": "Karriereguider"
    },
    "Article": {
        "ButtonText_BackToAllArticles": "Tilbage til alle artikler"
    },
    "ForgotPassword": {
        "ResetLinkAlert_Title": "Nulstil din adgangskode",
        "ResetLinkAlert_Subtitle": "Klik på linket til nulstilling af adgangskode i din e-mail for at oprette en ny adgangskode og logge ind på din konto.",
        "PasswordNotSetAlert_Message": "Adgangskode er ikke oprettet. Log ind med ",
        "ResetYourPassword": {
            "MainTitle": "Se resultaterne af dit Hubert-interview",
            "Subtitle": "Log ind for at se resultater, få feedback, modtag gode råd og meget mere.",
            "FormSectionTitle": "Nulstil din adgangskode",
            "Label_NewPassword": "Ny adgangskode",
            "Label_ConfirmNewPassword": "Bekræft ny adgangskode",
            "Error_NewPassword_Required": "Indtast en ny adgangskode.",
            "Error_Password_6_Characters": "Din nye adgangskode skal være mindst 6 tegn.",
            "Error_ConfirmNewPassword_Required": "Bekræft din nye adgangskode.",
            "Error_ConfirmNewPassword_NotMatch": "Adgangskoderne matcher ikke.",
            "Error_MalformedResetUrl": "Ugyldig sikkerhedskode. Prøv igen.",
            "Error_ResetPasswordFailed": "Vi havde et problem med at nulstille adgangskoden. Prøv igen.",
            "Error_WeakPassword": "Adgangskoden skal være mindst 6 tegn.",
            "Error_InvalidCode_Title": "Din anmodning om nulstilling af adgangskode er udløbet eller ugyldig.",
            "Error_InvalidCode_Subtitle": "Prøv at nulstille din adgangskode igen.",
            "ButtonText_SetNewPassword": "Opret ny adgangskode og log ind",
            "ButtonText_RememberYourPassword": "Kan du huske din adgangskode?",
            "ButtonText_SignInInstead": "Log ind i stedet"
        }
    },
    "PageNotFound": {
        "Title": "Siden blev ikke fundet",
        "Description": "Vi kan ikke finde siden, du leder efter.",
        "ButtonText_GoToDashboard": "Gå til Overblik",
        "ButtonText_GoToLogin": "Gå til Log ind"
    },
    "OldInterviewRedirectionModal": {
        "DescriptionLine1": "Genbrug af svar er endnu ikke tilgængeligt for dette interview. Vi forventer, at funktionen snart bliver tilgængelig, men du kan stadig tage interviewet nu.",
        "DescriptionLine2": "Fortsæt til interviewet ved at klikke på knappen nedenfor.",
        "ButtonText_TakeMeToTheInterview": "Gå til interviewet"
    },
    "UnsubscribeFromEmails": {
        "Title": "Er du sikker?",
        "Subtitle": "Du stopper med at modtage e-mails fra os om denne stilling:",
        "SelectTheReason": "Vælg venligst en årsag nedenfor.",
        "ReasonText1": "Jeg har fundet et andet job.",
        "ReasonText2": "Jeg er ikke længere interesseret i denne stilling.",
        "ReasonText3": "Andet",
        "ButtonText_Unsubscribe": "Afmeld e-mails om denne stilling",
        "Placeholder_YourReason": "Din årsag",
        "Success_Title": "Du er nu afmeldt e-mails om denne stilling.",
        "Loading": "Indlæser ...",
        "Error_YourReason_Required": "Indtast en årsag.",
        "Error_ServerIssue": "Afmelding mislykkedes på grund af en serverfejl."
    },
    "SocialLoginCallback": {
        "ButtonText_TryAgain": "Prøv igen"
    },
    "Outreach": {
        "CandidateNotFound": "Kandidaten blev ikke fundet",
        "CandidateNotFoundDesc": "Vi kunne ikke finde de interviewdetaljer, du leder efter.",
        "InterviewEnded": "Interviewet er afsluttet",
        "InterviewEndedDesc1": "Denne interviewsession er afsluttet eller ikke længere tilgængelig.",
        "InterviewEndedDesc2": "Tak for din tid. Hvis du har spørgsmål, så kontakt rekrutteringsteamet.",
        "ReadyTitle": "Er du klar til din samtale, {{firstName}}?",
        "InvitationDesc": "Hubert inviterer dig på vegne af {{companyName}} til en chatbaseret samtale, som tager ca. 1-2 minutter at gennemføre.",
        "Button_StartChat": "Start chatten",
        "CancelNotice": "Hvis du starter her, annullerer du det planlagte opkald til denne stilling.",
        "PreferNotToContinue": "Vil du ikke fortsætte?",
        "DeclineLabel": "Jeg er ikke interesseret i denne stilling. Ring eller skriv ikke til mig igen om denne stilling.",
        "Button_ConfirmAndDecline": "Bekræft og afvis",
        "Processing": "Behandler...",
        "Toast_DeclineSuccess": "Samtalen blev afvist.",
        "Toast_CancelVoiceInfo": "Telefonopkaldet er annulleret. Funktionen kommer snart.",
        "Toast_CancelError": "Det lykkedes ikke at annullere opkaldet. Prøv venligst igen.",
        "Footer_WithdrawConsent": "Du kan til enhver tid trække dit samtykke tilbage. Læs mere i ",
        "Footer_PrivacyPolicySuffix": "s privatlivspolitik",
        "Footer_And": " og ",
        "Footer_HubertPrivacyLink": "Huberts privatlivspolitik samt vilkår og betingelser",
        "Chat_InterviewWith": "Chat med {{companyName}}",
        "Chat_StatusConnected": "Forbundet",
        "Chat_StatusError": "Fejl",
        "Chat_StatusDisconnected": "Afbrudt",
        "Chat_StatusConnecting": "Forbinder...",
        "Chat_ReadyToStart": "Klar til at starte chatten?",
        "Chat_ButtonStart": "Start chat",
        "Chat_SayHello": "Sig hej for at starte chatten.",
        "Chat_EmptyState": "Send en besked for at starte chatten.",
        "Chat_SelectLanguage": "Vælg sprog",
        "Chat_Placeholder": "Skriv din besked...",
        "Chat_ButtonSend": "Send",
        "Chat_ButtonBack": "Tilbage",
        "LoadingCandidateDetails": "Indlæser kandidatdetaljer...",
        "FetchingCandidateDetails": "Henter kandidatdetaljer...",
        "Chat_StatusReady": "Venter på at oprette forbindelse...",
        "Chat_ForbiddenError": "Dette chatinterview er ikke længere tilgængeligt.",
        "Chat_GeneralError": "Kunne ikke starte chatten. Prøv venligst igen senere.",
        "Chat_SelectUiLanguage": "Sprog i menuen",
        "Chat_InterviewTitle": "Jobinterview"
    }
}
